import router from '../../router'
import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'
import { setAuthHeader } from '../../axios/axiosAPI'

const state = {
  authtoken: localStorage.getItem('authtoken'),
  userInfo: {
    themeColor: localStorage.getItem('themeColor')
  },
  accountParams: {
    totalProducts: localStorage.getItem('totalProducts'),
    client_name: localStorage.getItem('clientName')
  }
}

const getters = {
  getUserId: (state) => {
    return state.authtoken
  }
}

const actions = {
  getUser ({ commit }, credentials) {
    axios.defaults.withCredentials = true
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'login',
        payload: {
          username: credentials.username,
          password: credentials.password
        }
      })
        .then(response => {
          if (response.data.payload.loggedIn) {
            commit('SET_userLogin', response.data.payload.token)
            localStorage.setItem('authtoken', response.data.payload.token)
            setAuthHeader(response.data.payload.token)
            resolve(1)
          } else {
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getThemeColor ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getThemeColor',
        payload: {}
      })
        .then(response => {
          if (response.data.payload.theme_color) {
            commit('SET_theme_color', response.data.payload.theme_color)
            localStorage.setItem('themeColor', response.data.payload.theme_color)
            resolve(1)
          } else {
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  changeThemeColor ({ commit }, color) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'changeThemeColor',
        payload: {
          theme_color: color
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getAccountParams ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getAccountParams',
        payload: {}
      })
        .then(response => {
          if (response.data.payload) {
            console.log(response.data.payload)
            commit('SET_account_params', response.data.payload)
            localStorage.setItem('totalProducts', response.data.payload.totalProducts)
            localStorage.setItem('clientName', response.data.payload.client_name)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  authLogout ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'logout',
        payload: {}
      })
        .then(response => {
          if (response.data) {
            commit('SET_userLogout')
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_userLogin (state, token) {
    state.authtoken = token
  },
  SET_theme_color (state, data) {
    state.userInfo.themeColor = data
  },
  SET_account_params (state, data) {
    state.accountParams = data
  },
  SET_userLogout (state, token) {
    localStorage.removeItem('authtoken')
    state.authtoken = null
    localStorage.removeItem('themeColor')
    state.userInfo.themeColor = null
    localStorage.removeItem('totalProducts')
    localStorage.removeItem('clientName')
    state.accountParams.totalProducts = null
    state.accountParams.clientName = null
    location.reload()
    router.replace('/login')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js